import React from "react";
import { Logo } from "@/components/brand/Logo";
import { ShieldCheck, Users, MailX } from "lucide-react";

export function AuthLayout({ title, subtitle, children, tagline }) {
  return (
    <div className="min-h-screen flex bg-background">
      {/* Brand panel */}
      <div className="hidden lg:flex lg:w-1/2 flex-col justify-between p-12 text-white relative overflow-hidden"
        style={{ background: "radial-gradient(1200px 600px at 20% -10%, #0090D6 0%, transparent 55%), linear-gradient(160deg,#013A5A 0%,#006090 60%,#00527D 100%)" }}>
        <Logo theme="dark" size={30} />
        <div className="max-w-md relative z-10">
          <h2 className="font-display text-3xl font-extrabold leading-tight">
            {tagline || "A secure sign-on for authorized personnel and candidates."}
          </h2>
          <p className="mt-4 text-white/70 text-sm leading-relaxed">
            This is a private sign-on area — not a public marketing site. Access is limited to
            invited personnel and the candidates we're actively working with.
          </p>
          <div className="mt-8 space-y-3">
            {[[Users, "For authorized personnel and candidates only"],
              [ShieldCheck, "Protected by MFA and full audit trails"],
              [MailX, "We never send spam or marketing email — ever"]].map(([Icon, t], i) => (
              <div key={i} className="flex items-center gap-3 text-sm text-white/85">
                <span className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center"><Icon className="w-4 h-4 text-brand-cyan" /></span>
                {t}
              </div>
            ))}
          </div>
        </div>
        <p className="text-xs text-white/50 relative z-10">© Top-Recruit · A product of Ivy Consulting Group</p>
        <div className="absolute -right-32 -bottom-32 w-[420px] h-[420px] rounded-full border border-white/10" />
        <div className="absolute right-16 top-24 w-40 h-40 rounded-full border border-white/10" />
      </div>

      {/* Form panel */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md tr-animate-in">
          <div className="lg:hidden flex items-center justify-center mb-8"><Logo size={30} /></div>
          <div className="bg-card rounded-2xl border border-border shadow-[0_10px_40px_-15px_rgba(0,96,144,0.25)] p-8">
            <h1 className="font-display text-2xl font-bold text-slate-900">{title}</h1>
            {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
            <div className="mt-6">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
